<section class="records-main-section new-records-main-section custom-section">
  <div class="modal-header" *ngIf="isInModal" style="border-color: rgb(217 215 215);">
    <h3 style="font-size: large;">{{isUpdate ? 'Edit':'Add'}} {{ reportName }}</h3>
    <div class="modal-header-right">
      <button
        type="button"
        class="close"
        (click)="goBack()"
        data-dismiss="modal"
        aria-label="Close"
      >
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <form *ngIf="form" [formGroup]="form" [id]="'form-add-update'+(isInModal ? '-in-modal':'')"  class="custom-form custom-height" (ngSubmit)="onSubmit()" aria-describedby="required-fields-note">
      <div class="required-fields-explanation" role="note" tabindex="-1" id="required-fields-note">
        <p><span class="text-danger" aria-hidden="true">*</span> Indicates required fields</p>
      </div>
      <ng-container *ngIf="savedFields?.HeaderFields?.length">
        <ng-container *ngFor="let row of headerRowMap; let i = index">
          <div class="row mb-2" [class.collapse]="isHeaderRowCollapsed(row)">
            <ng-container *ngFor="let col of row">
              <div class="col" *ngIf="(!isFieldHidden(col) && !(isStyleOptionHidden(col.FieldName) || isColHidden(col.FieldKey))) || (styleOptionShowArray.includes(col.FieldName) || colShowArr.includes(col.FieldKey))">
                <ng-container
                  *ngTemplateOutlet="
                  inputTypeSelector(col);
                  context: { col: col }
                  "
                  ></ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="savedFields.TabData.length !== 1 && isPrintingForm">
        <ng-container *ngFor="let tab of rowColMap; let i = index">
          <h3 class="custom-title">{{ savedFields.TabData[i].Title }}</h3>
          <ng-container
            *ngTemplateOutlet="content; context: { tab: tab }"
          ></ng-container>
        </ng-container>
      </ng-container>
    <mat-tab-group *ngIf="savedFields.TabData.length !== 1 && !isPrintingForm"
      [selectedIndex]="tabIndex"
      (selectedTabChange)="formTabChange($event)"
      (keydown)="onTabKeyDown($event)"
      class="non-print-header record-action-mat-group"
      [class.accessible-tabs]="enableAccessibleFormTabs"
      [ngClass]="isInModal ? 'custom-tab-group':''"
      [attr.aria-label]="'Form sections with ' + savedFields.TabData.length + ' tabs'"
    >
      <ng-container *ngFor="let tab of rowColMap; let i = index">
        <mat-tab *ngIf="isTabHidden(i)"
          [disabled]="isActionBtnActive"
          [attr.tabindex]="enableAccessibleFormTabs ? (!isActionBtnActive && isTabHidden(i) ? (i === currentTabIndex ? 0 : -1) : -1) : null"
        >
          <ng-template mat-tab-label>
            <span
              class="custom-title"
              [ngClass]="i == currentTabIndex ? 'active-tab':''"
              [attr.aria-label]="savedFields.TabData[i].Title + ' tab'"
            >{{
              savedFields.TabData[i].Title
            }}</span>
          </ng-template>
          <ng-container
            *ngTemplateOutlet="content; context: { tab: tab }"
          ></ng-container>
        </mat-tab>
      </ng-container>
    </mat-tab-group>


    <ng-container *ngIf="savedFields.TabData.length === 1">
      <div class="section" *ngFor="let tab of rowColMap">
        <ng-container
          *ngIf="
            (userRole === 'admin' && !savedFields.TabData[0].HideForAdmin) ||
            (userRole === 'participant' &&
              !savedFields.TabData[0].HideForParticipants) ||
            userRole === 'super_admin'
          "
        >
          <ng-container
            *ngTemplateOutlet="content; context: { tab: tab }"
          ></ng-container>
        </ng-container>
      </div>
    </ng-container>
    <div class="modal-footer-bottom-row custom-position"  *ngIf="(savedFields.TabData.length > 1 || isCustomBtnActive) && isActionBtnActive">
      <div class="d-inline-block" *ngIf="!savedFields.HasCustomButtons">
        <button
          id="prev"
          class="alertButtonCancel justify-content-center mx-1"
          (click)="tabClick($event)"
          *ngIf="getButtonStatus(tabIndex,'Previous')"
          type="button"
        >
          Previous
        </button>
        <button
          id="next"
          class="alertButtonCancel justify-content-center mx-1"
          (click)="tabClick($event)"
          *ngIf="getButtonStatus(tabIndex,'Next')"
          type="button"
        >
          Next
        </button>
        <button
          id="saveNext"
          (click)="tabClick($event)"
          class="alertButtonSuccess justify-content-center mx-1"
          type="button"
          *ngIf="getButtonStatus(tabIndex,'SaveAndContinue')"
          [disabled]="(form.invalid || saveDisabled || hasChildTableErrors)"
        >
          Save and Continue
        </button>
        <button
          id="saveExit"
          class="alertButtonSuccess justify-content-center mx-1"
          (click)="tabClick($event)"
          *ngIf="getButtonStatus(tabIndex,'SaveAndExit')"
          [disabled]="(form.invalid || saveDisabled || hasChildTableErrors)"
          type="button"
        >
          Save and Exit
        </button>
        <button
          id="cancel"
          class="alertButtonCancel justify-content-center mx-1"
          (click)="tabClick($event)"
          *ngIf="getButtonStatus(tabIndex,'Cancel')"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div class="d-flex modal-action-buttons" [ngClass]="isInModal ?  'modal-action-buttons':''" *ngIf="savedFields.HasCustomButtons">
        <ng-container *ngFor="let col of footerRowMap[tabIndex]">
          <div class="col" *ngIf="(!(isStyleOptionHidden(col.FieldName))) || (styleOptionShowArray.includes(col.FieldName))">
            <ng-container
              *ngTemplateOutlet="
                inputTypeSelector(col);
                context: { col: col }
              "
            ></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <app-modal-action-btns
      [form]="form"
      (onReject)="goBack()"
      (onConfirm)="allowClose = true; onSubmit()"
      [disabled]="(form.invalid || saveDisabled || hasChildTableErrors)"
      [useFormSubmit]="false"
      [resetSubmitting]="resetSubmittingToken"
      class="custom-position"
      *ngIf="savedFields.TabData.length==1 && !isCustomBtnActive || !isActionBtnActive"
    ></app-modal-action-btns>

  </form>
  <ng-container *ngIf="!isInModal">
    <ng-container *ngIf="isUpdate && !isCopyRecord && savedFields.TabData.length">
      <ng-container *ngIf="recordCommonTemplates?.embeddedReport">
        <ng-container
        *ngTemplateOutlet="recordCommonTemplates.embeddedReport; context: { isFormPrinting: isPrintingForm, preventFilter: preventFilter, trigger: trigger }"
        ></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</section>

<ng-template let-tab="tab" #content>
  <div class="tabs-conatent-main edit-form">
    <div class="tab-inner-main-root-bx">
      <ng-container *ngFor="let row of tab; let i = index">
        <div class="row mlr-10" [class.collapse]="isTabRowCollapsed(row)">
          <ng-container *ngFor="let col of row">
            <div class="col mb-2" *ngIf="(!isFieldHidden(col) && !(isStyleOptionHidden(col.FieldName) || isColHidden(col.FieldKey))) || (styleOptionShowArray.includes(col.FieldName) || colShowArr.includes(col.FieldKey))">
              <ng-container
                *ngTemplateOutlet="
                  inputTypeSelector(col);
                  context: { col: col }
                "
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template let-col="col" #input>
  <div>
    <app-input
      class=" "
      [label]="formGroupAt(col)?.value?.Name"
      [infoText]="formGroupAt(col)?.value?.Info"
      [form]="formGroupAt(col)"
      controlName="Value"
      [type]="inputFieldType(col)"
      (change)="fileSelect($event, col, formGroupAt(col))"
      [placeholder]="inputFieldPlaceholder(col)"
      [piiData]="getPIIField(col)"
      [mask]="inputFieldMask(col)"
      [disabled]="isFieldReadonly(col) || !columnFilter(col)"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [isPrintingForm]="isPrintingForm"
      [fieldSize]="col.FieldSize"
      [PIIDecrypted]="formGroupAt(col)?.value?.DecryptedValue"
      [controlValue]="fieldIdToControl(col.FieldKey)?.value"
      [isRequired]="col.FormFieldSetting.Required || isColRequired(col.FieldKey)"
      [autocomplete]="inputFieldAutocomplete(col)"
      [errorMessagePrefix]="'Error - '"
    ></app-input>
  </div>
</ng-template>

<ng-template let-col="col" #urlReadonly>
  <div>
    <div class="custom-html-form">
      <label class="field-title" for="" *ngIf="!col?.FormFieldSetting?.IsFormFieldNameHidden">{{
        formGroupAt(col)?.value?.Name
      }}</label>
      <label for="" *ngIf="col?.FormFieldSetting?.IsFormFieldNameHidden"></label>
      <i
        class="icon-info"
        *ngIf="formGroupAt(col)?.value?.Info != null && formGroupAt(col)?.value?.Info != ''"
        [title]="formGroupAt(col)?.value?.Info"
      ></i>
      <div class="form-group-control d-flex">
        <a
          *ngIf="fieldIdToControl(col.FieldKey)?.value"
          class="link"
          (click)="openReadonlyUrlLink(col)"
          [title]="getReadonlyUrlDisplayText(col)"
        >{{ getReadonlyUrlDisplayText(col) }}</a>
        <span *ngIf="!fieldIdToControl(col.FieldKey)?.value" class="text-muted">—</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-col="col" #checkbox>
  <div>
    <app-checkbox
      class=" "
      [label]="formGroupAt(col)?.value?.Name"
      [infoText]="formGroupAt(col)?.value?.Info"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isFieldReadonly(col)"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [isRequired]="col.FormFieldSetting.Required || isColRequired(col.FieldKey)"
      [errorMessagePrefix]="'Error - '"
    ></app-checkbox>
  </div>
</ng-template>

<ng-template let-col="col" #select>
  <div>
    <app-select-search-scroll *ngIf="enableFormDropdownNgSelectValue"
      [options]="formGroupAt(col)?.value?.DropdownValues || []"
      [label]="formGroupAt(col)?.value?.Name"
      [infoText]="formGroupAt(col)?.value?.Info"
      [form]="formGroupAt(col)"
      controlName="Value"
      [searchable]="true"
      [staticOptions]="true"
      [disabled]="isFieldReadonly(col)"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="col.RelatedTableSingularName ||
        formGroupAt(col)?.value?.Name?.replace('Related ', '')
      "
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [modalLayer]="modalLayer"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      (selected)="setSelectedValue($event, formGroupAt(col))"
      [errorMessagePrefix]="'Error - '"
    ></app-select-search-scroll>
    <app-select *ngIf="!enableFormDropdownNgSelectValue"
      class=" "
      [options]="formGroupAt(col)?.value?.DropdownValues || []"
      [label]="formGroupAt(col)?.value?.Name"
      [key]="col.FieldKey"
      [infoText]="formGroupAt(col)?.value?.Info"
      [fieldName]="col.FieldName"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isFieldReadonly(col)"
      [isRelation]="col.IsRelation"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="col.RelatedTableSingularName ||
        formGroupAt(col)?.value?.Name?.replace('Related ', '')
      "
      [fromAction]="true"
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [modalLayer]="modalLayer"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
    >
    </app-select>
  </div>
</ng-template>

<ng-template let-col="col" #selectSearchScroll>
  <div>
    <app-select-search-scroll
      [label]="formGroupAt(col)?.value?.Name"
      [form]="formGroupAt(col)"
      controlName="Value"
      [options]="col.IsRelation ? (relatedOptions?.[col.FieldKey] || []) : selectOptions(col)"
      [extraOptions]="col.IsRelation ? [] : columnDataList[col.FieldKey]"
      [infoText]="formGroupAt(col)?.value?.Info"
      [minSearchLength]="3"
      [searchable]="isUserField(col)"
      [scrollable]="isUserField(col)"
      (selected)="setSelectedValue($event, formGroupAt(col))"
      (relatedSelected)="relatedSelected($event, col)"
      [disabled]="isFieldReadonly(col)"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [virtualScroll]="col.IsRelation ? true : false"
      [relatedFieldKey]="col.FieldKey"
      [isRelatedDataComponent]="col.IsRelation"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [passedTableKey]="relatedTableKey"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="
        col.RelatedTableSingularName || relatedSingularNames[col.Key] || col.Name.replace('Related ', '')
      "
      [modalLayer]="modalLayer"
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [dependentFieldKey]="col.DependentFieldKey ? getFieldName(col.DependentFieldKey) : ''"
      [dependentFieldValue]="col.DependentFieldKey ? fieldIdToControl(col.DependentFieldKey)?.value : 0"
      [restrictConditions]="getRestrictChoices(col)"
      [dropdownType]="col.DropdownLabelType"
      [errorMessagePrefix]="'Error - '"
    ></app-select-search-scroll>
  </div>
</ng-template>

<ng-template let-col="col" #select2>
  <div>
    <app-select-search-scroll *ngIf="enableFormDropdownNgSelectValue"
      [options]="formGroupAt(col)?.value?.DropdownValues || []"
      [label]="formGroupAt(col)?.value?.Name"
      [infoText]="formGroupAt(col)?.value?.Info"
      [multiple]="true"
      [searchable]="true"
      [staticOptions]="true"
      [closeOnSelect]="false"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isFieldReadonly(col)"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="
        formGroupAt(col)?.value?.Name.replace('Related ', '')
      "
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [modalLayer]="modalLayer"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      (selected)="setMultiSelectedValue($event, formGroupAt(col))"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [errorMessagePrefix]="'Error - '"
      [showItemRemove]="true"
    ></app-select-search-scroll>
    <app-select *ngIf="!enableFormDropdownNgSelectValue"
      class=" "
      [options]="formGroupAt(col)?.value?.DropdownValues || []"
      [label]="formGroupAt(col)?.value?.Name"
      [key]="col.FieldKey"
      [infoText]="formGroupAt(col)?.value?.Info"
      [multiple]="true"
      [fromAction]="true"
      [fieldName]="col.FieldName"
      [form]="formGroupAt(col)"
      [value]="formGroupAt(col)?.value?.Value"
      controlName="Value"
      [disabled]="isFieldReadonly(col)"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="
        formGroupAt(col)?.value?.Name.replace('Related ', '')
      "
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [modalLayer]="modalLayer"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      (selected)="setMultiSelectedValue($event, formGroupAt(col))"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      >
    </app-select>
  </div>
</ng-template>

<ng-template let-col="col" #html>
  <div class="">

    <div class="custom-html-form">
      <label *ngIf="!col?.FormFieldSetting?.IsFormFieldNameHidden" class="" for="">{{
        formGroupAt(col)?.value?.Name
      }}</label>
      <label for="" *ngIf="col?.FormFieldSetting?.IsFormFieldNameHidden" ></label>
      <div [class.border]="!isModalOverflowFixEnabled || isInModal" [class.p-1]="!isModalOverflowFixEnabled || isInModal" [style.min-height]="'40px'" [style.max-width]="!isModalOverflowFixEnabled || isInModal ? '100%' : null" [style.overflow]="!isModalOverflowFixEnabled || isInModal ? 'scroll' : null" [ngClass]="{'labelHidden':formGroupAt(col)?.value?.FormFieldSetting?.IsFormFieldNameHidden}">
        <div
          [innerHTML]="inputFieldPlaceholder(col) | safeHTML"
          >
        </div>
      </div>
    </div>
</div>
</ng-template>

<ng-template let-col="col" #button>
  <div class="custom-html-form">
    <div class=" ">
      <label for=""></label>
      <div  class="labelHidden p-1" style="margin-top:-5px">
        <button
          class="btn d-flex form-custom-button"
          type="button"
          *ngIf="!col.IsFormulaField && !col.IsUrlField"
          [title]="col.FormStyleOption.IsCustom ? getFieldValue(col) : col.Name"
          [disabled]="((col.FormStyleOption?.ButtonClickFunction === 'saveExit' || col.FormStyleOption?.ButtonClickFunction === 'saveNext') && (saveDisabled || hasChildTableErrors)) || shouldDisableCustomButton(col)"
          [ngStyle]="{
            'background-color': col?.FormStyleOption?.ButtonColor,
            'color': col?.FormStyleOption?.TextColor,
            '--button-bg': col?.FormStyleOption?.ButtonColor
          }"
          (click)="applyButtonActions(col)"
        >
            <div *ngIf="col?.FormStyleOption?.Icon && !(col?.FormStyleOption?.Icon.includes('fluent-') || col?.FormStyleOption?.Icon.includes('material-icons-') || col?.FormStyleOption?.Icon.includes('fl-'))" [innerHTML]="buttonIcons[col.FormStyleOption.Icon] | safeHTML"></div>
            <span
            *ngIf="col?.FormStyleOption?.Icon && (col?.FormStyleOption?.Icon.includes('fluent-') || col?.FormStyleOption?.Icon.includes('material-icons-') || col?.FormStyleOption?.Icon.includes('fl-'))"
            [ngClass]="col.FormStyleOption?.Icon"
            [ngStyle]="{
              'color':col.FormStyleOption?.IconColor || '#fff',
              'font-size':'30px'
            }"
            ></span>
            <span style="margin-top:3px" class="custom-button-text">
            <ng-container *ngIf="col.FormStyleOption.IsCustom">
              <ng-container>
                  {{getFieldValue(col) || ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!col.FormStyleOption.IsCustom">
              {{col.Name}}
            </ng-container>
          </span>
        </button>
        <button
          class="btn d-flex form-custom-button"
          type="button"
          *ngIf="col.IsFormulaField && col.IsUrlField"
          [ngStyle]="{
            'background-color': col?.FormFieldSetting?.FormFieldStyle?.ButtonColor,
            'color': col?.FormFieldSetting?.FormFieldStyle?.TextColor,
            '--button-bg': col?.FormFieldSetting?.FormFieldStyle?.ButtonColor
          }"
          (click)="applyButtonActions(col)"
        >
            <div *ngIf="col?.FormStyleOption?.Icon && !(col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('fluent-') ||  col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('material-icons-') || col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('fl-'))" [innerHTML]="buttonIcons[col.FormFieldSetting?.FormFieldStyle?.Icon] | safeHTML"></div>
            <span
            *ngIf="col?.FormFieldSetting?.FormFieldStyle?.Icon && (col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('fluent-') ||  col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('material-icons-') || col?.FormFieldSetting?.FormFieldStyle?.Icon.includes('fl-'))"
            [ngClass]="col.FormFieldSetting?.FormFieldStyle?.Icon"
            [ngStyle]="{
              'color':col.FormFieldSetting?.FormFieldStyle?.IconColor || '#fff',
              'font-size':'30px'
            }"
            ></span>
            <span style="margin-top:3px" class="custom-button-text" [title]="col.FormFieldSetting?.FormFieldStyle?.Name || col.LinkText || fieldIdToControl(col.FieldKey).value">
              {{ col.FormFieldSetting?.FormFieldStyle?.Name || col.LinkText || fieldIdToControl(col.FieldKey).value }}
            </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template let-col="col" #divider>
  <div class="divider-container my-2 mb-3">
    <div class="divider">
    </div>
  </div>
</ng-template>

<ng-template let-col="col" #header>
  <div class="">
    <div class="my-2 py-2 d-flex" [style.background]="col.FormStyleOption?.ButtonColor || '#fff'" [ngStyle]="{ 'justify-content': col?.FormStyleOption?.TextAlignment }">
      <ng-container *ngIf="col.FormStyleOption.IsCustom">
        <ng-container>
            <h1 class="heading-1" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting?.DefaultValue == 'large'">{{getFieldValue(col) || ''}}</h1>
            <h2 class="heading-2" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting?.DefaultValue == 'medium'">{{getFieldValue(col) || ''}}</h2>
            <h3 class="heading-3" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting?.DefaultValue == 'small'">{{getFieldValue(col) || ''}}</h3>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!col.FormStyleOption.IsCustom">
        <h1 class="heading-1" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting.DefaultValue == 'large'">{{col.Name}}</h1>
        <h2 class="heading-2" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting.DefaultValue == 'medium'">{{col.Name}}</h2>
        <h3 class="heading-3" [style.color]="col.FormStyleOption?.TextColor || 'var(--opengov-primary-black)'" *ngIf="col.FormFieldSetting.DefaultValue == 'small'">{{col.Name}}</h3>
      </ng-container>
    </div>
  </div>
</ng-template>
<ng-template let-col="col" #collapse>
  <ng-container *ngIf="isNewFormCollapsibleEnabled; else legacyCollapse">
    <button
      type="button"
      class="accordion-header"
      tabindex="0"
      (click)="col.IsHeader ? hideHeaderRows(col) : hideTabRows(col)"
      role="button"
      [attr.aria-expanded]="!isRowCollapsed(col)"
      [attr.aria-label]="col.FormFieldSetting?.FormFieldName"
    >
      <i [ngClass]="isRowCollapsed(col) ? 'icon-chv-right':'icon-chv-down'" class="accordion-chevron"></i>
      <span class="accordion-title">{{ col.FormFieldSetting?.FormFieldName }}</span>
    </button>
  </ng-container>
  <ng-template #legacyCollapse>
    <div class="collaps-header my-2"
      style="display: flex; justify-content: end; padding-right: 10px;" (keydown)="$event.preventDefault()" (click)="col.IsHeader ? hideHeaderRows(col) : hideTabRows(col)">
      <a class="title-link" title="Collapse/Expand Rows"
        data-toggle="collapse" role="button" aria-expanded="true" aria-controls="tab-parent-drop" (keydown)="$event.preventDefault()">
        <i [ngClass]="isRowCollapsed(col) ? 'icon-chv-down':'icon-chv-up'" style="font-size: 20px; font-weight: 900;"></i>
      </a>
    </div>
  </ng-template>
</ng-template>

<ng-template let-col="col" #textarea>
  <div *ngIf="isHtmlAllowed(col)" >

      <div class="custom-html-form ">
        <label class="" for="" *ngIf="!col?.FormFieldSetting?.IsFormFieldNameHidden" >{{
          col.Name
        }}</label>
        <label for="" *ngIf="col?.FormFieldSetting?.IsFormFieldNameHidden" ></label>
        <i
          class="icon-info "
          *ngIf="
            col.Info != null &&
            col.Info != ''
          "
          [title]="col.Info"
        ></i>
        <div>
          <div
            [innerHTML]="formGroupAt(col)?.value?.Value | safeHTML"
            >
          </div>
        </div>
      </div>
  </div>
  <div *ngIf="!isHtmlAllowed(col)">
    <app-textarea
      class=" "
      [label]="formGroupAt(col)?.value?.Name"
      [infoText]="formGroupAt(col)?.value?.Info"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isFieldReadonly(col)"
      [isHeader]="col.IsHeader"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRichTextEditor]="col?.FormFieldSetting?.IsRichTextFormat"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [isRequired]="col.FormFieldSetting.Required || isColRequired(col.FieldKey)"
      [errorMessagePrefix]="'Error - '"
    ></app-textarea>
  </div>
</ng-template>

<ng-template let-col="col" #file>
  <ng-container *ngIf="isA11yFileInputEnabled; else legacyFileTpl">
  <div [attr.data-file-field]="col.FieldKey">
    <app-input
      class="mb-2"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isDocumentSent(col) || isFieldReadonly(col) || !columnFilter(col)"
      [infoText]="formGroupAt(col)?.value?.Info"
      [label]="formGroupAt(col)?.value?.Name"
      type="file"
      (fileChange)="fileSelect($event, col, formGroupAt(col))"
      [isHeader]="col.IsHeader"
      [CustomFileInput]="true"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [FileExtensions]="col?.FormFieldSetting?.FileExtension"
      [IsFromForm]="true"
      [fileValue]="formGroupAt(col)?.controls?.Value?.value"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [isRequired]="col.FormFieldSetting.Required || isColRequired(col.FieldKey)"
      [errorMessagePrefix]="'Error - '"
    ></app-input>
    <div class="row mt-2" style="padding: 5px 0 !important">
      <ng-container *ngIf="isFileMissingTooltipEnabled && formGroupAt(col)?.controls?.Value?.value && formGroupAt(col)?.controls?.IsFileMissing?.value">
        <div class="view-document-row">
          <div class="file-missing-trigger-wrapper">
            <button type="button"
              class="file-missing-icon-btn"
              aria-label="Open tooltip."
              aria-haspopup="dialog"
              [attr.aria-controls]="'file-missing-tooltip-' + col.FieldKey"
              [attr.aria-expanded]="!!fileMissingTooltip.open[col.FieldKey]"
              (click)="fileMissingTooltip.toggle(col.FieldKey, $event)"
              (mouseenter)="fileMissingTooltip.show(col.FieldKey)"
              (mouseleave)="fileMissingTooltip.hide(col.FieldKey)"
              (focus)="fileMissingTooltip.show(col.FieldKey)"
              (blur)="fileMissingTooltip.hide(col.FieldKey)"
              (keydown)="fileMissingTooltip.onKeydown(col.FieldKey, $event)">
              <svg class="file-missing-icon-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M8.66658 8.66683H7.33325V4.66683H8.66658M8.66658 11.3335H7.33325V10.0002H8.66658M7.99992 1.3335C7.12444 1.3335 6.25753 1.50593 5.4487 1.84097C4.63986 2.176 3.90493 2.66706 3.28587 3.28612C2.03563 4.53636 1.33325 6.23205 1.33325 8.00016C1.33325 9.76827 2.03563 11.464 3.28587 12.7142C3.90493 13.3333 4.63986 13.8243 5.4487 14.1594C6.25753 14.4944 7.12444 14.6668 7.99992 14.6668C9.76803 14.6668 11.4637 13.9644 12.714 12.7142C13.9642 11.464 14.6666 9.76827 14.6666 8.00016C14.6666 7.12468 14.4941 6.25778 14.1591 5.44894C13.8241 4.6401 13.333 3.90517 12.714 3.28612C12.0949 2.66706 11.36 2.176 10.5511 1.84097C9.7423 1.50593 8.8754 1.3335 7.99992 1.3335Z" fill="currentColor"/>
              </svg>
            </button>
            <dialog *ngIf="fileMissingTooltip.open[col.FieldKey]"
              [id]="'file-missing-tooltip-' + col.FieldKey"
              class="file-missing-tooltip"
              [attr.aria-labelledby]="'file-missing-desc-' + col.FieldKey"
              [open]="true"
              (mouseenter)="fileMissingTooltip.show(col.FieldKey)"
              (mouseleave)="fileMissingTooltip.hide(col.FieldKey)"
              (keydown)="fileMissingTooltip.onKeydown(col.FieldKey, $event)">
              <span [id]="'file-missing-desc-' + col.FieldKey"
                class="file-missing-tooltip-text">File corrupted or missing</span>
              <button type="button"
                aria-label="Close tooltip."
                class="file-missing-tooltip-close"
                (click)="fileMissingTooltip.hide(col.FieldKey, $event)"
                (focus)="fileMissingTooltip.show(col.FieldKey)"
                (blur)="fileMissingTooltip.hide(col.FieldKey)">
                <i class="fe fe-x" aria-hidden="true"></i>
              </button>
            </dialog>
          </div>
          <a title="View Document" aria-label="View Document" class="view-document"
            target="_blank" rel="noopener noreferrer" [href]="formGroupAt(col)?.controls?.FileUrl?.value"
            [ngClass]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? 'disabled-link':''"
            [attr.tabindex]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? -1 : 0">
            {{ formGroupAt(col)?.controls?.Value?.value }}
          </a>
        </div>
      </ng-container>
      <a title="View Document" [attr.aria-label]="'View Document ' + formGroupAt(col)?.controls?.Value?.value + ', ' + formGroupAt(col)?.value?.Name"
        *ngIf="formGroupAt(col)?.controls?.Value?.value && (!isFileMissingTooltipEnabled || !formGroupAt(col)?.controls?.IsFileMissing?.value)"
        class="view-document"
        target="_blank" rel="noopener noreferrer" [href]="formGroupAt(col)?.controls?.FileUrl?.value"
        [ngClass]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? 'disabled-link':''"
        [attr.tabindex]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? -1 : 0">
        <i class="icon-description mr-2" style="vertical-align: middle !important;"></i>
        {{ formGroupAt(col)?.controls?.Value?.value }}
      </a>
      <a title="Create Document" aria-label="Create Document"
        *ngIf="!formGroupAt(col)?.controls?.Value?.value && isDocEnabled(col) && !isFieldReadonly(col)"
        style="margin-top: -24px; margin-left: 18px; vertical-align: middle !important;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        class="d-flex align-items-center">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v6a2 2 0 0 0 2 2h6v10a2 2 0 0 1-2 2h-6.81A6.5 6.5 0 0 0 4 11.498V4a2 2 0 0 1 2-2h6Z"
            fill="var(--opengov-primary-blurple-lite)" />
          <path
            d="M13.5 2.5V8a.5.5 0 0 0 .5.5h5.5l-6-6ZM12 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM7 18l.001 2.503a.5.5 0 1 1-1 0V18H3.496a.5.5 0 0 1 0-1H6v-2.5a.5.5 0 1 1 1 0V17h2.497a.5.5 0 0 1 0 1H7Z"
            fill="var(--opengov-primary-blurple-lite)" />
        </svg>
        Create Document
      </a>
      <div class="dropdown-menu">
        <a class="dropdown-item" (click)="getDocRouteLink(col, 'new')">Blank Document</a>
        <a class="dropdown-item" (click)="openTemplateModal(col)">From Template</a>
      </div>
      <div class="d-flex justify-content-center ml-auto align-items-center" style="margin-top: -25px; margin-right: 15px">
        <a title="Edit Document" aria-label="Edit Document"
          *ngIf="formGroupAt(col)?.controls?.Value?.value && isDoc(col) && !isFieldReadonly(col) && !isDocumentSent(col) && isUpdate && recordId != null && recordId > 0"
          (click)="getDocRouteLink(col, 'edit')" class="d-flex align-items-center mx-1">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2v6a2 2 0 0 0 2 2h4.92c-.596.22-1.144.554-1.558.97l-6.05 6.092a2.815 2.815 0 0 0-.728 1.279l-.525 2.03A2.082 2.082 0 0 0 10.3 22H5.5A1.5 1.5 0 0 1 4 20.5v-17A1.5 1.5 0 0 1 5.5 2H12Z"
              fill="var(--opengov-primary-blurple-lite)" />
            <path
              d="M13.5 2.5V8a.5.5 0 0 0 .5.5h5.5l-6-6ZM12.196 17.572l5.902-5.902a2.285 2.285 0 1 1 3.233 3.232l-5.903 5.902a2.684 2.684 0 0 1-1.247.707l-1.831.457a1.087 1.087 0 0 1-1.318-1.318l.457-1.83c.118-.473.362-.904.707-1.248Z"
              fill="var(--opengov-primary-blurple-lite)" />
          </svg>
        </a>
        <a title="Download Document" [attr.aria-label]="'Download Document ' + formGroupAt(col)?.controls?.Value?.value + ', ' + formGroupAt(col)?.value?.Name"
          *ngIf="formGroupAt(col)?.controls?.Value?.value && isUpdate" target="_blank"
          [href]="formGroupAt(col)?.controls?.FileUrl?.value + '/true'" class="download-document d-flex align-items-center mx-1">
          <i class="icon-download"></i>
        </a>
        <button type="button" class="custom-delete mx-1 d-flex align-items-center" *ngIf="formGroupAt(col)?.value?.Value && !isFieldReadonly(col)" title="Delete Document"
          [attr.aria-label]="'Delete Document ' + formGroupAt(col)?.controls?.Value?.value + ', ' + formGroupAt(col)?.value?.Name" (click)="openDeleteModal(confirmationDialog,col)" [id]="'delete-doc-btn-' + col.FieldKey + '-' + col.IsHeader">
          <i class="icon-delete delete-icon"></i>
        </button>
      </div>
    </div>
  </div>
  </ng-container>
  <ng-template #legacyFileTpl>
  <div>
    <app-input
      class="mb-2"
      [form]="formGroupAt(col)"
      controlName="Value"
      [disabled]="isDocumentSent(col) || isFieldReadonly(col) || !columnFilter(col)"
      [infoText]="formGroupAt(col)?.value?.Info"
      [label]="formGroupAt(col)?.value?.Name"
      type="file"
      (fileChange)="fileSelect($event, col, formGroupAt(col))"
      [isHeader]="col.IsHeader"
      [CustomFileInput]="true"
      [IsFormFieldNameHidden]="col?.FormFieldSetting?.IsFormFieldNameHidden"
      [FileExtensions]="col?.FormFieldSetting?.FileExtension"
      [IsFromForm]="true"
      [fileValue]="formGroupAt(col)?.controls?.Value?.value"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [IsRowDisplayOnScreen]="isColumnWithDisplayOnScreen(col)"
      [isRequired]="col.FormFieldSetting.Required || isColRequired(col.FieldKey)"
    ></app-input>
    <div class="row mt-2" style="padding: 5px 0 !important">
      <ng-container *ngIf="isFileMissingTooltipEnabled && formGroupAt(col)?.controls?.Value?.value && formGroupAt(col)?.controls?.IsFileMissing?.value">
        <div class="view-document-row">
          <div class="file-missing-trigger-wrapper">
            <button type="button"
              class="file-missing-icon-btn"
              aria-label="Open tooltip."
              aria-haspopup="dialog"
              [attr.aria-controls]="'file-missing-tooltip-' + col.FieldKey"
              [attr.aria-expanded]="!!fileMissingTooltip.open[col.FieldKey]"
              (click)="fileMissingTooltip.toggle(col.FieldKey, $event)"
              (mouseenter)="fileMissingTooltip.show(col.FieldKey)"
              (mouseleave)="fileMissingTooltip.hide(col.FieldKey)"
              (focus)="fileMissingTooltip.show(col.FieldKey)"
              (blur)="fileMissingTooltip.hide(col.FieldKey)"
              (keydown)="fileMissingTooltip.onKeydown(col.FieldKey, $event)">
              <svg class="file-missing-icon-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M8.66658 8.66683H7.33325V4.66683H8.66658M8.66658 11.3335H7.33325V10.0002H8.66658M7.99992 1.3335C7.12444 1.3335 6.25753 1.50593 5.4487 1.84097C4.63986 2.176 3.90493 2.66706 3.28587 3.28612C2.03563 4.53636 1.33325 6.23205 1.33325 8.00016C1.33325 9.76827 2.03563 11.464 3.28587 12.7142C3.90493 13.3333 4.63986 13.8243 5.4487 14.1594C6.25753 14.4944 7.12444 14.6668 7.99992 14.6668C9.76803 14.6668 11.4637 13.9644 12.714 12.7142C13.9642 11.464 14.6666 9.76827 14.6666 8.00016C14.6666 7.12468 14.4941 6.25778 14.1591 5.44894C13.8241 4.6401 13.333 3.90517 12.714 3.28612C12.0949 2.66706 11.36 2.176 10.5511 1.84097C9.7423 1.50593 8.8754 1.3335 7.99992 1.3335Z" fill="currentColor"/>
              </svg>
            </button>
            <dialog *ngIf="fileMissingTooltip.open[col.FieldKey]"
              [id]="'file-missing-tooltip-' + col.FieldKey"
              class="file-missing-tooltip"
              [attr.aria-labelledby]="'file-missing-desc-' + col.FieldKey"
              [open]="true"
              (mouseenter)="fileMissingTooltip.show(col.FieldKey)"
              (mouseleave)="fileMissingTooltip.hide(col.FieldKey)"
              (keydown)="fileMissingTooltip.onKeydown(col.FieldKey, $event)">
              <span [id]="'file-missing-desc-' + col.FieldKey"
                class="file-missing-tooltip-text">File corrupted or missing</span>
              <button type="button"
                aria-label="Close tooltip."
                class="file-missing-tooltip-close"
                (click)="fileMissingTooltip.hide(col.FieldKey, $event)"
                (focus)="fileMissingTooltip.show(col.FieldKey)"
                (blur)="fileMissingTooltip.hide(col.FieldKey)">
                <i class="fe fe-x" aria-hidden="true"></i>
              </button>
            </dialog>
          </div>
          <a title="View Document" aria-label="View Document" class="view-document"
            target="_blank" rel="noopener noreferrer" [href]="formGroupAt(col)?.controls?.FileUrl?.value"
            [ngClass]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? 'disabled-link':''">
            {{ formGroupAt(col)?.controls?.Value?.value }}
          </a>
        </div>
      </ng-container>
      <a title="View Document" aria-label="View Document"
        *ngIf="formGroupAt(col)?.controls?.Value?.value && (!isFileMissingTooltipEnabled || !formGroupAt(col)?.controls?.IsFileMissing?.value)"
        class="view-document"
        target="_blank" rel="noopener noreferrer" [href]="formGroupAt(col)?.controls?.FileUrl?.value"
        [ngClass]="(!recordId || formGroupAt(col)?.controls?.Base64EncodedFile?.value || isDifferentFile(col)) ? 'disabled-link':''">
        <i class="icon-description mr-2" style="vertical-align: middle !important;"></i>
        {{ formGroupAt(col)?.controls?.Value?.value }}
      </a>
      <a title="Create Document" aria-label="Create Document"
        *ngIf="!formGroupAt(col)?.controls?.Value?.value && isDocEnabled(col) && !isFieldReadonly(col)"
        style="margin-top: -24px; margin-left: 18px; vertical-align: middle !important;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        class="d-flex align-items-center">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v6a2 2 0 0 0 2 2h6v10a2 2 0 0 1-2 2h-6.81A6.5 6.5 0 0 0 4 11.498V4a2 2 0 0 1 2-2h6Z"
            fill="var(--opengov-primary-blurple-lite)" />
          <path
            d="M13.5 2.5V8a.5.5 0 0 0 .5.5h5.5l-6-6ZM12 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM7 18l.001 2.503a.5.5 0 1 1-1 0V18H3.496a.5.5 0 0 1 0-1H6v-2.5a.5.5 0 1 1 1 0V17h2.497a.5.5 0 0 1 0 1H7Z"
            fill="var(--opengov-primary-blurple-lite)" />
        </svg>
        Create Document
      </a>
      <div class="dropdown-menu">
        <a class="dropdown-item" (click)="getDocRouteLink(col, 'new')">Blank Document</a>
        <a class="dropdown-item" (click)="openTemplateModal(col)">From Template</a>
      </div>
      <div class="d-flex justify-content-center ml-auto align-items-center" style="margin-top: -25px; margin-right: 15px">
        <a title="Edit Document" aria-label="Edit Document"
          *ngIf="formGroupAt(col)?.controls?.Value?.value && isDoc(col) && !isFieldReadonly(col) && !isDocumentSent(col) && isUpdate && recordId != null && recordId > 0"
          (click)="getDocRouteLink(col, 'edit')" class="d-flex align-items-center mx-1">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2v6a2 2 0 0 0 2 2h4.92c-.596.22-1.144.554-1.558.97l-6.05 6.092a2.815 2.815 0 0 0-.728 1.279l-.525 2.03A2.082 2.082 0 0 0 10.3 22H5.5A1.5 1.5 0 0 1 4 20.5v-17A1.5 1.5 0 0 1 5.5 2H12Z"
              fill="var(--opengov-primary-blurple-lite)" />
            <path
              d="M13.5 2.5V8a.5.5 0 0 0 .5.5h5.5l-6-6ZM12.196 17.572l5.902-5.902a2.285 2.285 0 1 1 3.233 3.232l-5.903 5.902a2.684 2.684 0 0 1-1.247.707l-1.831.457a1.087 1.087 0 0 1-1.318-1.318l.457-1.83c.118-.473.362-.904.707-1.248Z"
              fill="var(--opengov-primary-blurple-lite)" />
          </svg>
        </a>
        <a title="Download Document" aria-label="Download Document"
          *ngIf="formGroupAt(col)?.controls?.Value?.value && isUpdate" target="_blank"
          [href]="formGroupAt(col)?.controls?.FileUrl?.value + '/true'" class="d-flex align-items-center mx-1">
          <i class="icon-download"></i>
        </a>
        <a class="custom-delete mx-1 d-flex align-items-center" *ngIf="formGroupAt(col)?.value?.Value && !isFieldReadonly(col)" title="Delete Document"
          aria-label="Delete Document" (click)="openDeleteModal(confirmationDialog,col)">
          <i class="icon-delete delete-icon"></i>
        </a>
      </div>
    </div>
  </div>
  </ng-template>
</ng-template>

<ng-template let-col="col" #report>
  <ng-container *ngIf="!isInModal">
    <div *ngIf="(showCol(col) && !isStyleOptionHidden(col.FieldName)) || styleOptionShowArray.includes(col.FieldName)">
      <ng-container *ngIf="recordCommonTemplates?.tabReportSection">
        <ng-container *ngTemplateOutlet="recordCommonTemplates.tabReportSection;context: { reportKey: col.FormFieldSetting.DefaultValue, index:col.TabIndex, isFormPrinting: isPrintingForm, preventFilter: preventFilter, trigger: trigger }"
        ></ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- Child Table: renders for 'CHILD_TABLE' design elements only (flag-gated). 'report' uses old ngx-datatable. -->
<ng-template let-col="col" #childTable>
  <ng-container *ngIf="!isInModal">
    <div *ngIf="col.DbFieldType === 'CHILD_TABLE' || (showCol(col) && !isStyleOptionHidden(col.FieldName)) || styleOptionShowArray.includes(col.FieldName)">
      <app-child-table-embedded
        [embeddedSetting]="col.EmbeddedSetting"
        [tableKey]="col.DbFieldType === 'CHILD_TABLE' ? '' : (col.ApplicationTableKey || '')"
        [reportKey]="col.EmbeddedSetting?.MatchRecordsReportKey || col.FormFieldSetting?.DefaultValue || ''"
        [parentRecordId]="id"
        [parentTableKey]="route.getTableKey()"
        [applicationKey]="route.getApplicationKey()"
        [editable]="col.EmbeddedSetting?.MatchRecordReportAllowInlineEdit !== '0' && !col.FormFieldSetting?.Readonly"
        (validationStatusChange)="onChildTableValidationStatusChange(col.FieldKey, $event)"
      ></app-child-table-embedded>
    </div>
  </ng-container>
</ng-template>

<ng-template #confirmationDialog let-modal>
  <ng-container *ngIf="isA11yFileInputEnabled; else legacyConfirmationDialog">
  <div class="modal-header">
    <h4 class="modal-title" id="delete-doc-modal-title">Please Confirm</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancelDeleteDocument()" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" id="delete-doc-modal-desc">
    Are you sure you want to delete this Document?
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger delete-modal-cancel-btn"
      mat-flat-button
      (click)="cancelDeleteDocument()"
      aria-describedby="delete-doc-modal-desc"
      >
      Cancel
    </button>
    &nbsp;&nbsp;
    <button
      type="button"
      class="btn btn-primary delete-modal-confirm-btn"
      mat-flat-button
      (click)="confirmDeleteDocument()"
      #deleteConfirmBtn
      aria-describedby="delete-doc-modal-desc"
      >
      Confirm
    </button>
  </div>
  </ng-container>
  <ng-template #legacyConfirmationDialog>
  <div class="modal-header">
    <h4 class="modal-title">Please Confirm</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    Are you sure you want to delete this Document?
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      mat-flat-button
      (click)="modal.close()"
      >
      Cancel
    </button>
    &nbsp;&nbsp;
    <button
      type="button"
      class="btn btn-primary"
      mat-flat-button
      (click)="deleteDocument()"
      >
      Confirm
    </button>
  </div>
  </ng-template>
</ng-template>

<app-record-common-templates
  [recordId]="recordId"
  [relationTabs]="relationTabs"
  [reportDetails]="reportDetails"
  [reports]="reports"
  [summaryfieldId]="summaryfieldId"
  [isInViewMode]="false"
  [currentTabIndex]="currentTabIndex"
  (refreshReportDetails)="refreshReportDetails($event, $event)"
  (messageDialogClosed)="closeMessageModal($event)"
  (openAddRelatedModalOutput)="openAddEditRelatedModal($event.report,$event.id,$event.tableId,$event.reportId)"
  (openRelatedModal)="openViewRelatedRecord($event.report,$event.id,$event.tableId,$event.reportId, $event.formKey)"
></app-record-common-templates>
